<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('extracurriculares.course_types.page_title')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('extracurriculares.course_types.new_type')}}</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingCourseType" class="headline">{{$t('extracurriculares.course_types.new_type')}}</span>
                        <span v-show="editingCourseType" class="headline">{{$t('extracurriculares.course_types.edit_type')}}</span>
                    </v-card-title>

                    <v-card-text>

                        <text-input
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.name')"
                            :v-errors="errors"
                            :value.sync="form.name"
                            name="name"
                            v-validate="'required'"
                        ></text-input>

                        <radio-input
                          name="payment_type"
                          :form="form"
                          :items="this.payment"
                          :label="$t('extracurriculares.course_types.form.payment_type')"
                          :v-errors="errors"
                          :value.sync="form.payment_type"
                          v-validate="'required'"
                          :color="'primary'"
                        >
                        </radio-input>

                        <v-text-field
                            v-if="form.payment_type === 'type_payment'"
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.price')"
                            :v-errors="errors"
                            :value.sync="form.price"
                            v-model="form.price"
                            name="price"
                            v-money="money"
                            v-validate="'required'"
                        ></v-text-field>

                        <v-text-field
                            v-if="form.payment_type === 'type_payment'"
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.employee_discount')"
                            v-model="form.employee_discount"
                            name="employee_discount"
                            v-money="number"
                            v-validate.disable="'required|min_value:0|max_value:100'"
                            data-vv-name="employee_discount"
                            :error-messages="errors.collect('employee_discount')"
                        ></v-text-field>

                        <v-text-field
                            v-if="form.payment_type === 'type_payment'"
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.early_payment_discount')"
                            v-model="form.early_payment_discount"
                            name="early_payment_discount"
                            v-money="number"
                            v-validate.disable="'required|min_value:0|max_value:100'"
                            data-vv-name="early_payment_discount"
                            :error-messages="errors.collect('early_payment_discount')"
                        ></v-text-field>

                        <v-text-field
                            v-if="form.payment_type === 'type_payment'"
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.general_discount')"
                            v-model="form.general_discount"
                            name="general_discount"
                            v-money="number"
                            v-validate.disable="'required|min_value:0|max_value:100'"
                            data-vv-name="general_discount"
                            :error-messages="errors.collect('general_discount')"
                        ></v-text-field>

                        <text-input
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.siesa_client_type')"
                            :v-errors="errors"
                            :value.sync="form.siesa_client_type"
                            name="siesa_client_type"

                        ></text-input>

                        <text-input
                            :form="form"
                            :label="$t('extracurriculares.course_types.form.siesa_cash_flow')"
                            :v-errors="errors"
                            :value.sync="form.siesa_cash_flow"
                            name="siesa_cash_flow"

                        ></text-input>

                        <check-input
                          name="status"
                          :form="form"
                          :label="$t('extracurriculares.course_types.form.status')"
                          :value.sync="form.status"
                          :color="'primary'"
                          :v-errors="errors"
                        >
                        </check-input>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$t('extracurriculares.course_types.form.cancel')}}</v-btn>
                        <v-btn v-if="!editingCourseType" color="blue darken-1" flat @click="saveCourseType">{{$t('extracurriculares.course_types.form.save')}}</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updateCourseType">{{$t('extracurriculares.course_types.form.update')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="courseTypes"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ $t(`extracurriculares.course_types.form.${props.item.payment_type}`) }}</td>
                <td class="text-xs-center">${{ formatNumber(props.item.price) }}</td>
                <td class="text-xs-center">{{ props.item.employee_discount }}%</td>
                <td class="text-xs-center">{{ props.item.early_payment_discount }}%</td>
                <td class="text-xs-center">{{ props.item.general_discount }}%</td>
                <td class="text-xs-center">
                  <v-checkbox
                    :key="props.item.id"
                    :name="`check_${props.item.id}`"
                    :input-value="props.item.status"
                    @change="handleCoursetypeStatus(props.item.id, props.item.status)"
                    color="primary"
                    class="center"
                  ></v-checkbox>
                </td>
                <td>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="editCourseType(props.item.id)"
                      slot="activator"
                    >
                      edit
                    </v-icon>
                    <span>{{$t('extracurriculares.course_types.edit')}}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="deleteCourseType(props.item.id)"
                      slot="activator"
                    >
                      delete
                    </v-icon>
                    <span>{{$t('extracurriculares.course_types.delete')}}</span>
                  </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
import { VMoney } from 'v-money'
export default {
  name: 'enrollments-show-view',
  directives: {money: VMoney},
  data() {
    return {
      headers: [
        { text: this.$t('extracurriculares.course_types.form.name'), align: 'center', value: 'start_date' },
        { text: this.$t('extracurriculares.course_types.form.payment_type'), align: 'center', value: 'finish_date' },
        { text: this.$t('extracurriculares.course_types.form.price'), align: 'center', value: 'school_year' },
        { text: this.$t('extracurriculares.course_types.form.employee_discount'), align: 'center', value: 'school_year' },
        { text: this.$t('extracurriculares.course_types.form.early_payment_discount'), align: 'center', value: 'school_year' },
        { text: this.$t('extracurriculares.course_types.form.general_discount'), align: 'center', value: 'school_year' },
        { text: this.$t('extracurriculares.course_types.form.status'), align: 'center', value: 'enrollment_responsible' },
        { text: this.$t('extracurriculares.course_types.form.actions'), align: 'center', value: 'start_date', sortable: false }
      ],
      courseTypes: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        name: '',
        payment_type: '',
        price: '',
        status: true,
        employee_discount: 0,
        early_payment_discount: 0,
        general_discount: 0,
        siesa_client_type: '',
        siesa_cash_flow: '',
      }),
      showSucessMessage: false,
      editingCourseType: false,
      payment: [
        { value: "type_payment", text: this.$t("extracurriculares.course_types.form.type_payment") },
        { value: "course_payment", text: this.$t("extracurriculares.course_types.form.course_payment") }
      ],
      money: {
          decimal: ',',
          thousands: '.',
          prefix: '$ ',
          suffix: '',
          precision: 0,
          masked: false
      },
      number: {
          decimal: '.',
          thousands: '',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.getCoursetypes()
  },
  methods: {
    async getCoursetypes() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/extracurriculares/course_types')
      this.courseTypes = data;
      this.loadingTable = false;
    },
    close() {
      this.form.clear();
      this.form.reset();
      this.dialog = false
    },
    async saveCourseType() {
      if (await this.formHasErrors()) return

      const result = await this.form.post('/api/extracurriculares/course_type', this.form)

      if (result.status === 200) {
        this.getCoursetypes()
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('extracurriculares.course_types.messages.saved_ok'),
          modal: false
        })
      }

      this.close()
    },
    editCourseType(id_course_type) {
      const courseTypeToEdit = this.courseTypes.filter(courseType => courseType.id === id_course_type)[0];
      this.editingCourseType = true;
      this.dialog = true;
      this.form = new Form({
        name: courseTypeToEdit.name,
        payment_type: courseTypeToEdit.payment_type,
        price: courseTypeToEdit.price,
        status: courseTypeToEdit.status,
        id: courseTypeToEdit.id,
        employee_discount: courseTypeToEdit.employee_discount,
        early_payment_discount: courseTypeToEdit.early_payment_discount,
        general_discount: courseTypeToEdit.general_discount,
        siesa_client_type: courseTypeToEdit.siesa_client_type,
        siesa_cash_flow: courseTypeToEdit.siesa_cash_flow,
      });



    },
    deleteCourseType(id_course_type) {
      axios.delete(`/api/extracurriculares/course_type/${id_course_type}`)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.deleted) {
              this.courseTypes = this.courseTypes
                .filter(course_type => course_type.id !== id_course_type);
              this.$store.dispatch('responseMessage', {
                type: 'success',
                text: this.$t(resp.data.message),
                modal: false
              })
              return
            }
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: this.$t(resp.data.message),
              modal: false
            })
          }
        })
        .catch(error => console.log(error));
    },
    updateCourseType() {

      this.form.put('/api/extracurriculares/course_type')
        .then(resp => {
          if (resp.status === 200) {
            this.courseTypes = this.courseTypes.map(course_type => {
              if (course_type.id === this.form.id) {
                course_type = Object.assign({}, resp.data.course_type);
              }
              return course_type;
            })
            this.dialog = false;
            this.editingCourseType = false;
            this.form = new Form({
              name: '',
              payment_type: '',
              price: '',
              status: true,
              employee_discount: 0,
              early_payment_discount: 0,
              general_discount: 0,
              siesa_client_type: '',
              siesa_cash_flow: '',
            })
          }
        })
        .catch(error => console.log(error));
    },
    handleCoursetypeStatus(id_course_type, status) {
      axios.put('/api/extracurriculares/course_type/state', { id: id_course_type, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.courseTypes = this.courseTypes.map(course_type => {
              if (course_type.id === id_course_type) {
                course_type.status = !status;
              }
              return course_type;
            })
          }
        })
    },
    formatNumber(number) {
      if(!number || typeof number === 'undefined') {
          return 0;
      } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    }
  }
}
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/manage_columbus/course_types.vue